import { InflatedListItemProduct } from '../list/ListTypes'
import { ClipspecIconicProductData } from './clipspec-api/ClipspecIntegrationAPI'
import { getProductImageRenderSpec, ImageRotation } from '../utils/ProductRenderSpec'
import { getDefaultSkinOrientation, getSkinSlotPositions } from '../products/productUtils'
import { renderToCanvas } from '../components/ConfigurableProductCanvasView'
import { getProductImageUrl } from '../products/getProductImageUrl'
import { logErrorDebug } from '../debug/debugLogging'
import { getClipspecConfiguredProductPayload } from './getClipspecConfiguredProductPayload'

const ClipspecImageSize = 400

export function getImageLoadFailureCount(payload: ClipspecIconicProductData[]) {
  return payload.filter(it => it.image === null).length
}

export async function getClipspecProductDataPayload(list: readonly InflatedListItemProduct[]): Promise<ClipspecIconicProductData[]> {
  return Promise.all(
    list.map<Promise<ClipspecIconicProductData>>(async configuredProduct => {
      const { skinImageRotation, imageScale, slotPositions, skinImage } = getProductImageRenderSpec(
        configuredProduct.skinProduct.image,
        configuredProduct.skinProduct.imageScale,
        configuredProduct.skinProduct.orientation,
        configuredProduct.skinProduct.imageOrientation,
        getDefaultSkinOrientation(configuredProduct.skinProduct),
        getSkinSlotPositions(configuredProduct.skinProduct),
      )

      let imageData: string | null = null

      try {
        const canvas = document.createElement('canvas')
        canvas.width = ClipspecImageSize
        canvas.height = ClipspecImageSize

        await renderToCanvas(
          canvas,
          getProductImageUrl(skinImage),
          imageScale ?? 1,
          skinImageRotation === ImageRotation.QuarterTurnAnticlockwise ? -0.25 : 0,
          slotPositions.map((slot, index) => {
            const { interfaceProduct, mechProduct } = configuredProduct.configuredButtons[index]

            return {
              ...slot,
              foregroundImageSrc: getProductImageUrl(interfaceProduct.image),
              backgroundImageSrc: getProductImageUrl(mechProduct?.image) ?? null,
            }
          }),
        )

        imageData = canvas.toDataURL()
      } catch (e) {
        logErrorDebug('error generating image')
      }

      return {
        ...getClipspecConfiguredProductPayload(configuredProduct),
        image: imageData,
      }
    }),
  )
}
